var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNothingCataloguedYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 97,
    viewBox: "0 0 99 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.27 34.748V62.7581L2 52.388L11.27 34.748Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4295 81.3982L18.2695 75.5382V43.4082L22.0095 57.3882L28.4295 81.3982Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5998 80.9984L64.6198 51.2184L60.1798 34.6284L55.8998 18.6383L39.9498 16.0984L16.2598 12.3184L20.9698 29.8983L23.5298 39.4684L23.8398 40.6284L25.2998 46.0783L27.5798 54.5984L34.0098 78.6083L36.6498 88.4583L76.2898 94.7784L72.5998 80.9984ZM52.3698 62.4784L50.4798 69.2284L46.3298 63.5483L38.2698 52.5183L38.0498 52.2184L38.2698 51.4384L40.7398 42.6383L42.0798 37.8683L47.9198 45.8683L48.6798 46.9084L54.4998 54.8784L52.3698 62.4784Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8395 40.6284L22.5995 41.2384V41.2484L18.2695 43.4084V59.2585L11.2695 62.7585V34.7484L20.9695 29.8984L23.5295 39.4684L23.8395 40.6284Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0095 78.6079L28.4295 81.3979L22.0095 57.3879L18.2695 43.4079L22.5995 41.2479V41.2379L23.8395 40.6279L25.2995 46.0779L27.5795 54.5979L34.0095 78.6079Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6798 46.9082L48.2598 47.1182L42.6798 49.8982L38.2698 52.1082L38.0498 52.2182L38.2698 51.4382L40.7398 42.6382L42.0798 37.8682L47.9198 45.8682L48.6798 46.9082Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4998 54.8782L52.3698 62.4782L50.4798 69.2282L46.3298 63.5482L38.2698 52.5182L38.0498 52.2182L38.2698 52.1082L42.6798 49.8982L48.2598 47.1182L48.6798 46.9082L54.4998 54.8782Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8998 8.63834L55.8998 18.6383L39.9498 16.0984L16.2598 12.3184L36.2598 2.31836L75.8998 8.63834Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2894 84.7787L76.2894 94.7787L72.5994 80.9987L64.6194 51.2187L60.1794 34.6287L55.8994 18.6387L75.8994 8.63867L96.2894 84.7787Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingCataloguedYet);
export default __webpack_public_path__ + "static/media/nothing-catalogued-yet.f00d458def0d3c20d58fc05b42b433f8.svg";
export { ForwardRef as ReactComponent };